export enum enumDatesDropdownType {
  THIS_MONTH,
  PREVIOUS_MONTH,
  THIS_YEAR,
  CHOOSE_DATE_RANGE,
}
